import { Box, Card, Snackbar, Typography, useTheme } from "@mui/material";
import { AavoToastContent } from "./types";
import { AavoIconButton } from "../buttons/AavoIconButton";
import { faTimes } from "@fortawesome/pro-regular-svg-icons";

export interface AavoToastProps {
	content: AavoToastContent | undefined;
	closeToast: () => void;
}

export const AavoToast = ({ content, closeToast }: AavoToastProps) => {
	const { palette } = useTheme();

	return (
		<Snackbar
			open={content != undefined}
			onClose={() => {
				closeToast();
			}}
			anchorOrigin={
				content?.anchorOrigin ?? {
					vertical: "bottom",
					horizontal: "center"
				}
			}
			autoHideDuration={2500}
		>
			<Card
				sx={{
					padding: 2,
					paddingX: 2.5,
					display: "flex",
					flexDirection: "column",
					borderRadius: 2,
					boxShadow: "0 4px 20px rgba(0,0,0,0.12), 0 1px 6px rgba(0,0,0,0.08)",
					borderLeft: "3px solid",
					borderLeftColor: "primary.main",
					minWidth: 280,
				}}
			>
				<Box
					sx={{
						display: "flex",
						flex: 1,
						justifyContent: "space-between",
						alignItems: "center",
						gap: 1.5
					}}
				>
					<Typography variant={"subtitle1"} sx={{ fontWeight: 600 }}>{content?.title}</Typography>
					{content?.hideCloseButton !== true && (
						<AavoIconButton
							icon={faTimes}
							color={"black"}
							sx={{
								padding: 0.25,
								opacity: 0.5,
								"&:hover": { opacity: 1 },
							}}
							onClick={() => {
								closeToast();
							}}
						/>
					)}
				</Box>
				{
					content?.message == null ? null
						: typeof content.message === "string" ? (
								<Typography
									variant={"body1"}
									sx={{
										paddingTop: 0.75,
										wordWrap: "break-word",
										color: palette.grey[600],
										lineHeight: 1.5,
									}}
								>
									{content.message}
								</Typography>
							)
							: content.message
				}
			</Card>
		</Snackbar>
	);
};
